import React from 'react';

const Title = ({ subtitle }) => {

  return(
    <h3 className="subtitle">
      { subtitle }
    </h3>
  )
}

export default Title;